import { LOAD, load } from 'model/guestLoanSearch';
import { guestLoanSelector } from 'selectors/guestLoanSearch';

export const guestColumnMeta = () => [
  {
    id: 'number',
    label: 'Loan Number',
    disablePadding: false,
    sortId: 'number',
    renderer: (value) => value,
  },
  {
    id: 'type',
    label: 'Type',
    disablePadding: false,
    sortId: 'type',
    renderer: (value) => value,
  },
];

export const TablePaginationProps = {
  action: load,
  actionType: LOAD,
  hasFspId: true,
  guestLoanSelector,
};
